export default __webpack_public_path__ + "static/media/igloo.9981b077.png";